import { render, staticRenderFns } from "./AlertsCount.vue?vue&type=template&id=4e15575e&"
import script from "./AlertsCount.vue?vue&type=script&lang=js&"
export * from "./AlertsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e15575e')) {
      api.createRecord('4e15575e', component.options)
    } else {
      api.reload('4e15575e', component.options)
    }
    module.hot.accept("./AlertsCount.vue?vue&type=template&id=4e15575e&", function () {
      api.rerender('4e15575e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/AlertsCount.vue"
export default component.exports